import { render, staticRenderFns } from "./StockMovementItem.vue?vue&type=template&id=67fb1e6b&"
import script from "./StockMovementItem.vue?vue&type=script&lang=js&"
export * from "./StockMovementItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockMovementItem.vue"
export default component.exports